import './checklist.scss';
import { useState, useEffect, useCallback } from 'react';
import api from 'api';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'types';

function Checklist({
    item,
    ticketId
}: {
    item: any
    ticketId: number | undefined
}) {
    const params: any = useParams();
    const user = useSelector((state: RootState) => state.user);

    const [checklist, setChecklist] = useState<any>({
        Id: null,
        Description: '',
        TicketId: null,
        Items: [],
    });

    const addChecklistItem = (val: string) => {
        if (ticketId) {
            api.ticket.checklist.item.add(ticketId, user.Id, val).then(() => { getChecklist() })
            // if (!checklist) {
            //     console.log('ticketId', ticketId)
            //     api.ticket.checklist.add(ticketId!, "Checklist").then(data => {
            //         api.ticket.checklist.item.add(data, val).then(() => {
            //             getChecklist();
            //         })
            //     });
            // } else {
            //     api.ticket.checklist.get(ticketId!).then(() => api.ticket.checklist.item.add(checklist.Id!, val).then(() => { getChecklist() }))
            // }
        }
    }

    const completeChecklistItem = (id: number, isCompleted: boolean) => {
        var items: any[] = [...checklist.Items];
        items[items.findIndex((x: any) => x.Id === id)].IsCompleted = isCompleted;
        setChecklist({
            ...checklist,
            Items: items
        })
        api.ticket.checklist.item.complete(id, ticketId as number, isCompleted);
    }

    const getChecklist = useCallback(() => {
        api.ticket.checklist.get(ticketId!).then((data) => {
         setChecklist(data)});
    }, [ticketId]);

    const remove = (id: number) => {
        api.ticket.checklist.item.remove(id, ticketId as number, user.Id);
        setChecklist({
            ...checklist,
            Items: checklist.Items.filter((x: any) => x.Id !== id)
        })
    }

    const moveItem = (id: number, position: number /* 1 = one position up,2 = one position down */) => {

        api.ticket.checklist.item.remove(id, ticketId as number, user.Id);
        setChecklist({
            ...checklist,
            Items: checklist.Items.filter((x: any) => x.Id !== id)
        })
    }

    const validURL = (str: string) => {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;a-z\\d%_.~+=-]*)?');// query string
        // '+ (\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    const urlify = (str: string) => {

        const arr = str.split(' ');
        return arr.map((x: string) => {
            if (validURL(x)) {
                return `<a href="${x}" target="_blank">${x}</a>`;
            } else {
                return x;
            }
        }).join(' ');
    }

    useEffect(() => {
        setChecklist(item);
    }, [item])

    return (
        <div className="input-group checklist">
            <label>Checklist</label>
            <ul>
                {checklist?.Items?.length > 0 ? checklist?.Items.map((x: any, i: number) => {
                    return (
                        <li key={i}>
                            {/* {i == (checklist?.Items.length - 1) ?
                                <i title='Click to move item one position up' className="fal fa-arrow-up" onClick={() => moveItem(x.Id, 1)}></i>
                                :
                                <i title='Click to move item one position down' className="fal fa-arrow-down" onClick={() => moveItem(x.Id, 2)}></i>
                            } */}
                            <input type="checkbox" checked={x.IsCompleted} onChange={() => completeChecklistItem(x.Id, !x.IsCompleted)} />
                            <span style={{ textDecoration: `${x.IsCompleted ? 'line-through' : ''}` }} dangerouslySetInnerHTML={{ __html: urlify(x.Description) }}></span>
                            <i className="fal fa-times" onClick={() => remove(x.Id)}></i>
                            {/* <i className="fal fa-pencil" onClick={() => remove(x.Id)}></i> */}
                        </li>
                    )
                }) : (<></>)}
                <li className="new">
                    <input
                        style={{ width: "100%" }}
                        type="text"
                        placeholder="New"
                        onKeyUp={e => {
                            if (e.key === "Enter") {
                                addChecklistItem(e.currentTarget.value);
                                e.currentTarget.blur();
                                e.currentTarget.value = '';
                            }
                        }}
                    />
                </li>
            </ul>
        </div>
    )
}

export default Checklist;